export enum EDesignBriefStatus {
  DRAFT = 'D',
  SUBMITTED = 'S',
  SECTION_HEAD_RECEIVED = 'H',
  TWC_RECEIVED = 'T',
  DESIGNER_RECEIVED = 'G',
  FINISHED = 'F',
  CANCELLED = 'C',
  COMMENTED = 'CM',
  REVISED = 'RV',
}

export enum EDesignBriefAction {
  SRP = 'SRP',
  TWC = 'TWC',
  TWD = 'TWD',
  CANCELLED = 'Cancelled',
  DRAFT = 'Draft',
  NO_ACTION = '-',
}
